import { MigrationManifest, PersistConfig, Storage, Transform, createMigrate } from "redux-persist";
import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2";

export interface SdkPersistConfig {
  version?: number;
  storage: Storage;
  whitelist?: string[];
  transforms?: Transform<any, any, any, any>[];
  migrations?: MigrationManifest;
}

export function getPersistConfig({
  version = 2,
  storage,
  whitelist = [],
  transforms = [],
  migrations = {},
}: SdkPersistConfig): PersistConfig<any, any, any, any> {
  const persistConfig: PersistConfig<any, any, any, any> = {
    key: "root",
    migrate: createMigrate(migrations, { debug: false }),
    stateReconciler: autoMergeLevel2,
    storage,
    transforms,
    version,
    whitelist,
  };

  return persistConfig;
}
